import { streamGroq, GroqMissingKeyError } from './groq-client';

export async function aiPolishCR(description: string, rationale: string, onStream: (chunk: string) => void): Promise<void> {
  const system = `You are a senior project manager writing a formal Change Request. Tighten the description into 2 plain-English sentences. Then write a polite-but-firm note to the client explaining the rationale and impact. Markdown.`;
  try {
    await streamGroq({
      messages: [{ role: 'system', content: system }, { role: 'user', content: `Description: ${description}\n\nRationale: ${rationale}` }],
      temperature: 0.3, onStream,
    });
  } catch (err) {
    if (err instanceof GroqMissingKeyError) { onStream('\n\n⚠️ No Groq API key set. Click the Settings gear ⚙ to add your free key.'); return; }
    onStream(`\n\n⚠️ ${err instanceof Error ? err.message : 'Groq error'}`);
  }
}
